import { AccessibleSVG } from '@core/svg';
/**
 * Left Caret SVG Icon
 */
export const CaretLeft = (props) => (<AccessibleSVG width="100%" height="100%" viewBox="0 0 36 36" {...props}>
    <path filter={props.shadow ? 'url(#shadowFilter)' : ''} fillRule="evenodd" clipRule="evenodd" d="M15.722 18L23.3253 10.3968C23.8862 9.83584 23.8862 8.92631 23.3253 8.36532C22.7643 7.80433 21.8547 7.80433 21.2937 8.36532L12.6748 16.9843C12.1138 17.5453 12.1138 18.4548 12.6748 19.0158L21.2937 27.6348C21.8547 28.1958 22.7643 28.1958 23.3253 27.6348C23.8862 27.0738 23.8862 26.1643 23.3253 25.6033L15.722 18Z" fill="currentColor"/>
  </AccessibleSVG>);
